var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadNotificationDarkOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.395,
    height: 59.115,
    viewBox: "0 0 51.395 59.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12353",
    "data-name": "Group 12353",
    transform: "translate(-84.066 -102.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12727",
    "data-name": "Path 12727",
    d: "M109.768,162.1a5.932,5.932,0,0,0,5.932-5.932H103.834a5.932,5.932,0,0,0,5.932,5.932Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12352",
    "data-name": "Group 12352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12816",
    "data-name": "Path 12816",
    d: "M130.689,141.9a1.946,1.946,0,0,1-.447-1.245V125.634a14.082,14.082,0,0,1-5.057,1.431v13.581a7.011,7.011,0,0,0,1.627,4.5l2.013,2.392H90.7l2.009-2.4a7.019,7.019,0,0,0,1.625-4.487v-16.9a15.6,15.6,0,0,1,15.4-15.716c.275,0,.544.032.815.048a14.228,14.228,0,0,1,2.847-4.73,20.243,20.243,0,0,0-24.12,20.419v16.874a1.948,1.948,0,0,1-.447,1.242l-3.893,4.65a3.672,3.672,0,0,0,2.779,6.049h44.174a3.676,3.676,0,0,0,2.716-6.032Z",
    fill: "#455079"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18141",
    "data-name": "Rectangle 18141",
    width: 18.461,
    height: 18.461,
    rx: 9.23,
    transform: "translate(114.7 103.667)",
    fill: "#2F64F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadNotificationDarkOutline);
export default __webpack_public_path__ + "static/media/unread-notification-dark-outline.dceb6d5b0f237fcc9b7aa841c9d9b688.svg";
export { ForwardRef as ReactComponent };